import { SET_SELECTED_ENERGY_SOURCES } from 'actions';

export function setSelectedEnergySources(selectedEnergySources: Array<string>) {
  return { selectedEnergySources, type: SET_SELECTED_ENERGY_SOURCES };
}
